import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
    const { t } = useLanguage();
    const [isMobile, setIsMobile] = useState(false);

    // Telefon numarası (ülke kodu ile birlikte, başında + olmadan)
    const whatsappNumber = '905379760651';

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Sadece mobil cihazlarda göster
    if (!isMobile) {
        return null;
    }

    const handleWhatsAppClick = () => {
        const lang = navigator.language.toLowerCase(); // cihaz dili
        const whatsappNumber = "905379760651";

        let message = '';

        if (lang.startsWith('tr')) {
            message = 'Merhaba! Korsan Taksi hakkında bilgi almak istiyorum.';
        }
        else if (lang.startsWith('en')) {
            message = 'Hello! I would like to get information about the Pirate Taxi service.';
        }
        else if (lang.startsWith('ar')) {
            message = 'مرحبًا! أود الحصول على معلومات حول خدمة التاكسي القرصان.';
        }
        else if (lang.startsWith('ru')) {
            message = 'Здравствуйте! Я хотел бы получить информацию о службе пиратского такси.';
        }
        else {
            // Dil eşleşmezse varsayılan İngilizce
            message = 'Hello! I would like to get information about the Pirate Taxi service.';
        }

        const encoded = encodeURIComponent(message);
        window.open(`https://wa.me/${whatsappNumber}?text=${encoded}`, '_blank');
    };

    return (
        <button
            className="whatsapp-button"
            onClick={handleWhatsAppClick}
            aria-label={t('chatOnWhatsApp')}
            title={t('chatOnWhatsApp')}
        >
            <svg
                viewBox="0 0 32 32"
                className="whatsapp-icon"
                fill="currentColor"
            >
                <path d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.467c-2.482 0-4.908-0.646-7.07-1.87l-0.507-0.292-5.245 1.408 1.408-5.245-0.292-0.507c-1.224-2.162-1.87-4.588-1.87-7.07 0-7.467 6.067-13.533 13.533-13.533s13.533 6.067 13.533 13.533c0 7.467-6.067 13.533-13.533 13.533zM21.867 18.267c-0.323-0.162-1.917-0.947-2.213-1.053s-0.513-0.162-0.729 0.162c-0.216 0.323-0.837 1.053-1.027 1.269s-0.378 0.243-0.701 0.081c-0.323-0.162-1.365-0.503-2.599-1.604-0.961-0.857-1.609-1.915-1.797-2.238s-0.020-0.498 0.142-0.659c0.146-0.146 0.323-0.378 0.485-0.567s0.216-0.323 0.323-0.539c0.108-0.216 0.054-0.405-0.027-0.567s-0.729-1.756-0.999-2.405c-0.264-0.632-0.532-0.547-0.729-0.557-0.188-0.009-0.405-0.011-0.621-0.011s-0.567 0.081-0.864 0.405c-0.297 0.323-1.133 1.107-1.133 2.701s1.159 3.133 1.321 3.349c0.162 0.216 2.287 3.491 5.541 4.896 0.774 0.335 1.379 0.535 1.849 0.685 0.777 0.247 1.485 0.212 2.043 0.129 0.623-0.093 1.917-0.784 2.187-1.541s0.27-1.405 0.189-1.541c-0.081-0.135-0.297-0.216-0.621-0.378z" />
            </svg>
        </button>
    );
};

export default WhatsAppButton;
